import OtherUserTolltip from '../InfoPanel/ToolTip/OtherUserTolltip';
import ActiveUserToolTip from '../InfoPanel/ToolTip/ActiveUserToolTip';
import { UserAvatarGroupProps } from '../../types/UserTypes';

const UserAvatarGroup: React.FC<UserAvatarGroupProps> = ({ users, maxVisible = 3 }) => {
  const visibleUsers = users.slice(0, maxVisible);
  const remainingCount = Math.max(0, users.length - maxVisible);

  const colors = ['bg-[#E84D31]', 'bg-[#2563EB]', 'bg-[#F59E0B]'];

  return (
    <div className="flex items-center">
      <div className="flex -space-x-3">
        {visibleUsers.map((user, i) => (
          <ActiveUserToolTip key={user.id} user={user} colorClass={colors[i]} />
        ))}
        {remainingCount > 0 && (
          <OtherUserTolltip users={users} remainingCount={remainingCount} maxVisible={maxVisible} />
        )}
      </div>
    </div>
  );
};

export default UserAvatarGroup;
